export default __webpack_public_path__ + "static/media/crystalshard.74e6bc1b.jpg";